module.exports = __webpack_public_path__ + "img/img_sheet_save.675231f1.png";